import { css } from '@emotion/css'
import { spacing, colors, fontFamily } from '@offerzen/pinata-shame'

const styles = {
  container: css({
    // the 60px correspond to the navbar
    minHeight: 'calc(100vh - 60px)',
    background: 'white',
    paddingTop: 50,
  }),

  content: css({
    padding: spacing.medium,
    fontFamily: fontFamily.body,

    '& input': {
      color: colors.jumbo,
    },

    '& input::placeholder': {
      color: '#d1d1d1',
    },
  }),
}

export default styles
